function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } it = o[Symbol.iterator](); return it.next.bind(it); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { getValueByIdentifier as getValue } from '../tags/values/get-by-identifier';
import { updateValueByIdentifier } from '../tags/values/update-by-identifier';
import { IDENTIFIERS } from '../types/Identifiers';
import { TAG_TYPES } from '../types/TagTypes';
import PROPS from '../types/Props';
var OG_IMAGE = IDENTIFIERS.OG_IMAGE,
    OG_IMAGE_WIDTH = IDENTIFIERS.OG_IMAGE_WIDTH,
    OG_IMAGE_HEIGHT = IDENTIFIERS.OG_IMAGE_HEIGHT;
export var DEFAULT_WIDTH = 2500;
export var DEFAULT_HEIGHT = 1330;
var MAX_IMAGE_PIXELS = 5100 * 5100;
export function buildOgImagePreview(url, width, height, method) {
  if (method === void 0) {
    method = 'fit';
  }

  var urlOrName = url;

  if (!urlOrName) {
    return urlOrName;
  }

  if (isAbsoluteUrl(urlOrName)) {
    urlOrName = extractImageNameFromWixMediaUrl(urlOrName);
  }

  if (!urlOrName) {
    return urlOrName;
  }

  return "https://static.wixstatic.com/media/" + urlOrName + "/v1/" + method + "/w_" + width + ",h_" + height + ",al_c/" + urlOrName;
}
export function buildOgImageFullUrl(url) {
  var urlOrName = url;

  if (!urlOrName || urlOrName === '') {
    return undefined;
  }

  if (isAbsoluteUrl(urlOrName)) {
    urlOrName = extractImageNameFromWixMediaUrl(urlOrName);
  }

  if (!urlOrName) {
    return url;
  }

  return "https://static.wixstatic.com/media/" + urlOrName;
}
export function buildOgImage(tags) {
  var result = {
    src: '',
    width: '',
    height: ''
  };
  var urlOrName = getValue(tags, OG_IMAGE);

  if (!urlOrName) {
    return result;
  }

  result.src = urlOrName;

  if (isAbsoluteUrl(urlOrName)) {
    urlOrName = extractImageNameFromWixMediaUrl(urlOrName);
  }

  if (!urlOrName) {
    return result;
  }

  result.src = "https://static.wixstatic.com/media/" + urlOrName;
  var width = getValue(tags, OG_IMAGE_WIDTH);
  var height = getValue(tags, OG_IMAGE_HEIGHT);

  if (width && height) {
    if (width * height > MAX_IMAGE_PIXELS) {
      var resized = resizeImage(width, height, DEFAULT_WIDTH);
      result.src += "/v1/fill/w_" + resized.width + ",h_" + resized.height + ",al_c/" + urlOrName;
      result.width = "" + resized.width;
      result.height = "" + resized.height;
    } else {
      result.src += "/v1/fill/w_" + width + ",h_" + height + ",al_c/" + urlOrName;
    }
  } else {
    var meta = getOgImageMeta(tags);

    if (meta && meta.width && meta.height) {
      var _resized = resizeImage(meta.width, meta.height, DEFAULT_WIDTH);

      result.src += "/v1/fill/w_" + _resized.width + ",h_" + _resized.height + ",al_c/" + urlOrName;
      result.width = "" + _resized.width;
      result.height = "" + _resized.height;
    } else {
      result.src += "/v1/fit/w_" + DEFAULT_WIDTH + ",h_" + DEFAULT_HEIGHT + ",al_c/" + urlOrName;
    }
  }

  return result;
}
export function applyOgImageModifications(tags) {
  var _buildOgImage = buildOgImage(tags),
      src = _buildOgImage.src,
      width = _buildOgImage.width,
      height = _buildOgImage.height;

  return [[OG_IMAGE, src], [OG_IMAGE_WIDTH, width], [OG_IMAGE_HEIGHT, height]].reduce(function (acc, curr) {
    var identifier = curr[0],
        value = curr[1];

    if (value) {
      var newTags;

      if (identifier === OG_IMAGE) {
        newTags = updateRelatedOgImagesFields(tags, value);
      }

      newTags = updateValueByIdentifier(acc, identifier, value);
      return newTags;
    } else {
      return acc;
    }
  }, tags);
}

function resizeImage(width, height, maxWidth, maxHeight) {
  if (maxHeight === void 0) {
    maxHeight = DEFAULT_HEIGHT;
  }

  width = parseInt(width, 10);
  height = parseInt(height, 10);

  if (width > maxWidth || height > maxHeight) {
    return {
      width: maxWidth,
      height: Math.floor(height / width * maxWidth)
    };
  }

  return {
    width: width,
    height: height
  };
}

function getOgImageMeta(tags) {
  var ogImage = tags.find(function (tag) {
    var type = tag.type,
        _tag$props = tag.props,
        props = _tag$props === void 0 ? {} : _tag$props;

    if (type === TAG_TYPES.META) {
      return props[PROPS.PROPERTY] === 'og:image';
    }

    return false;
  });
  return (ogImage || {}).meta;
}

function isAbsoluteUrl(url) {
  return /^https?/.test(url) || /^\/\//.test(url);
}

function extractImageNameFromWixMediaUrl(url) {
  var pattern = 'static.wixstatic.com/media/';
  var index = url.indexOf(pattern);

  if (index !== -1) {
    var name = url.substr(index + pattern.length);

    if (name.indexOf('/') !== -1) {
      return '';
    }

    return name;
  }

  return '';
}

export function updateRelatedOgImagesFields(tags, newOgImageValue) {
  var isMeta = function isMeta(type) {
    return type === TAG_TYPES.META;
  };

  var isOgImage = function isOgImage(props) {
    return props && props[PROPS.PROPERTY] === 'og:image';
  };

  var ogImage = tags.find(function (_ref) {
    var type = _ref.type,
        props = _ref.props;
    return isMeta(type) && isOgImage(props);
  });

  if (ogImage) {
    var originalOgImageValue = ogImage.props.content;

    var isEndsWithImage = function isEndsWithImage(props) {
      return props[PROPS.PROPERTY].endsWith('image');
    };

    var hasOldOgImageValue = function hasOldOgImageValue(props) {
      return props[PROPS.CONTENT] && props[PROPS.CONTENT] === originalOgImageValue;
    };

    var isPropertyExists = function isPropertyExists(props) {
      return props && typeof props[PROPS.PROPERTY] === 'string';
    };

    var isOgImageRelated = function isOgImageRelated(_ref2) {
      var type = _ref2.type,
          props = _ref2.props;
      return isMeta(type) && isPropertyExists(props) && isEndsWithImage(props) && hasOldOgImageValue(props);
    };

    for (var _iterator = _createForOfIteratorHelperLoose(tags), _step; !(_step = _iterator()).done;) {
      var tag = _step.value;

      if (isOgImageRelated(tag) && !isOgImage(tag.props)) {
        tag.props[PROPS.CONTENT] = newOgImageValue;
      }
    }
  }

  return tags;
}